import Amplify, { Auth, Storage } from "aws-amplify";
import Joi from "joi-browser";
import React from "react";
import { Offcanvas } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { getSettings } from "store/settings";
import { getTelegram } from "store/telegram";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";
import deleteIcon from "include/images/delete-icon.svg";
import plusIcon from "include/images/plus-1.svg";

//  Components
import AlertError from "common/alert/alertError";
import AlertSuccess from "common/alert/alertSuccess";
import Form from "common/form/form";
import NextButton from "common/form/submitButton";
import SelectSearch from "common/form/selectSearch";
import { sortBy } from "lodash";
import { getGame, loadBGGames } from "store/games";
import { dateAsUtc } from "utils/dateConversion";
import { PLAYER_VS_PLAYER_PRIZE_TYPES, LUCK_GAMES_SLUGS } from "utils/constants";
import { addPvPContest, loadPvPContests, updatePvPContest } from "store/pvp";

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: "us-east-1",
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET,
    region: "us-east-1",
  },
});
Auth.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: "us-east-1", // REQUIRED - Amazon Cognito Region
  },
  Storage: {
    bucket: process.env.REACT_APP_S3BUCKET, //REQUIRED -  Amazon S3 bucket
    region: "us-east-1",
  },
});

class AddFlyer extends Form {
  fileInputRef = React.createRef(null);
  initState = {
    loading: false,
    data: {
      name: "",
      entryFee: 0,
      entryFeeType: { name: "Point", value: 1 },
      prize: 0,
      prizeType: { name: "Point", value: 1 },
      bgGame: {},
      isActive: true,
      numberOfPlayers: 2,
      description: "",
    },
    errors: {},
    edit: false,
  };
  state = { ...structuredClone(this.initState) };

  componentDidMount = () => {
    this.props.loadBGGames({ isActive: true, isComingSoon: false }, () => {
      this.setState({ bgGamesLoading: false });
    });
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal !== prevProps.showModal) {
      this.clearData();
      if (this.props.showModal) {
        const data = { ...this.state.data };
        if (this.props.edit) {
          data.name = this.props.edit.name;
          data.entryFee = this.props.edit.entryFee;
          data.entryFeeType = PLAYER_VS_PLAYER_PRIZE_TYPES.find(({ value }) => value === this.props.edit.entryFeeType);

          data.prize = this.props.edit.prize;
          data.prizeType = PLAYER_VS_PLAYER_PRIZE_TYPES.find(({ value }) => value === this.props.edit.prizeType);

          data.numberOfPlayers = this.props.edit.numberOfPlayers;
          data.description = this.props.edit.description;
          data.bgGame = {
            name: this.props.edit?.bgGame?.name,
            value: this.props.edit?.bgGame?.id,
            data: this.props.edit?.bgGame,
          };
        }
        this.setState({
          data,
          edit: this.props.edit,
        });
      }
    }
  };
  handleResponse = (res) => {
    this.setState({ loading: false });
    if (res?.status === 200) {
      toast(<AlertSuccess message="Information Saved" />, { containerId: 1 });
      this.clearData();
      this.props.loadPvPContests({ page: 1 }, () => {});
      this.props.toggleModal();
    } else {
      toast(<AlertError message={res.data && res.data.message} />, { containerId: 1 });
    }
  };
  doSubmit = () => {
    this.setState({ loading: true });
    const data = { ...this.state.data };

    const payload = {
      name: data.name,
      entryFee: Number(data.entryFee),
      entryFeeType: Number(data.entryFeeType.value),
      prize: Number(data.prize),
      prizeType: Number(data.prizeType.value),
      bgGameId: data.bgGame.value,
      isActive: data.isActive,
      description: data.description,
    };

    if (this.state.edit) {
      this.props.updatePvPContest(this.state.edit._id, payload, this.handleResponse);
    } else {
      payload.numberOfPlayers = Number(data.numberOfPlayers);
      this.props.addPvPContest(payload, this.handleResponse);
    }
  };

  schema = {
    name: Joi.string().required(),
    entryFee: Joi.number().required(),
    entryFeeType: Joi.object().keys({
      name: Joi.string().allow(""),
      value: Joi.number().required(),
      data: Joi.object().allow(null),
    }),
    description: Joi.string().required(),
    prize: Joi.number().required(),
    prizeType: Joi.object().keys({
      name: Joi.string().allow(""),
      value: Joi.number().required(),
      data: Joi.object().allow(null),
    }),

    bgGame: Joi.object().keys({
      data: Joi.object().allow(null),
      name: Joi.string().allow(""),
      value: Joi.string().required(),
    }),

    isActive: Joi.boolean().required(),
    numberOfPlayers: Joi.number().required(),
  };

  clearData = () => {
    this.setState({ ...this.initState });
  };

  onChangeSelect = (selected) => {
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    data[selected.name] = selected.currentTarget;

    delete errors[selected.name];
    this.setState({ data, errors });
  };

  render() {
    const { bgGames } = this.props.getGame;
    return (
      <Offcanvas
        className={"offcanvas offcanvas-end  custom-offcanvas-pannel "}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="rewardPannel"
        placement="right"
        name="rewardPannel"
        backdrop={true}
      >
        <Offcanvas.Header>
          <h5>{this.props.edit ? "Edit " : "Add a"} Player vs Player Contest</h5>
          <div
            className="btn_close pointer"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.props.toggleModal}
          >
            <img src={closeIcon} alt="" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form-check-outer">
            <div className="new-form-group">
              <div className="row">{this.renderInput("name", "Contest Name", "", "text")}</div>
            </div>
            <div className="new-form-group">
              <div className="row">
                <div className="d-flex align-items-center justify-content-between">
                  <label className="form-label">BG Game</label>
                </div>
                <SelectSearch
                  name="bgGame"
                  options={sortBy(bgGames, ["name"])
                    .filter((game) => game?.applicableForTelegramGame && !LUCK_GAMES_SLUGS.includes(game.slug))
                    .map((game) => ({
                      name: game.name,
                      value: game.id,
                      data: game,
                    }))}
                  label="Select BG Game"
                  value={this.state.data.bgGame}
                  error={this.state.errors.bgGame}
                  onChange={this.onChangeSelect}
                  isLoading={this.state.bgGamesLoading}
                />
              </div>
            </div>
            <div className="new-form-group">
              <div className="row">
                <div className="col-12 new-form-group">{this.renderTextarea("description", "Description", "", "")}</div>
              </div>
            </div>
            <div className="new-form-group">
              <div className="row">
                <div className="d-flex align-items-center justify-content-between">
                  <label className="form-label">Entry Fee Type</label>
                </div>
                <SelectSearch
                  name="entryFeeType"
                  options={PLAYER_VS_PLAYER_PRIZE_TYPES}
                  label="Entry Fee Type"
                  value={this.state.data.entryFeeType}
                  error={this.state.errors.entryFeeType}
                  onChange={this.onChangeSelect}
                />
              </div>
            </div>
            <div className="new-form-group">
              <div className="row">{this.renderInput("entryFee", "Entry Fee", "", "number")}</div>
            </div>
            <div className="new-form-group">
              <div className="row">
                <div className="d-flex align-items-center justify-content-between">
                  <label className="form-label">Prize Type</label>
                </div>
                <SelectSearch
                  name="prizeType"
                  options={PLAYER_VS_PLAYER_PRIZE_TYPES}
                  label="Select Prize Type"
                  value={this.state.data.prizeType}
                  error={this.state.errors.prizeType}
                  onChange={this.onChangeSelect}
                />
              </div>
            </div>
            <div className="new-form-group">
              <div className="row">{this.renderInput("prize", "Prize", "", "number")}</div>
            </div>
            <div className="new-form-group">
              <div className="row">
                {this.renderInput("numberOfPlayers", "Number Of Players", "", "number", true, true)}
              </div>
            </div>
          </div>
        </Offcanvas.Body>
        <div className="offcanvas-footer">
          <NextButton
            classData="btn btn-default btn-block h-100"
            label="Save"
            loading={this.state.loading}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </Offcanvas>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadPvPContests: (params, callback) => dispatch(loadPvPContests(params, callback)),

  addPvPContest: (data, callback) => dispatch(addPvPContest(data, callback)),
  updatePvPContest: (id, data, callback) => dispatch(updatePvPContest(id, data, callback)),
  loadBGGames: (params, callback) => dispatch(loadBGGames(params, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
  getSettings: getSettings(state),
  getGame: getGame(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddFlyer));
